import { render, staticRenderFns } from "./AttributeList.vue?vue&type=template&id=10db53f2&scoped=true&"
import script from "./AttributeList.vue?vue&type=script&lang=ts&"
export * from "./AttributeList.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeList.vue?vue&type=style&index=0&id=10db53f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db53f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
